import React from 'react'
import agent from '../agent'
import TransactionList from './widgets/TransactionList';
import Loading from './widgets/Loading'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Pager from 'react-pager'
import {
  ACCOUNT_PAGE_LOADED,
  ACCOUNT_NEXT_PAGE_LOADED,
  ACCOUNT_PAGE_UNLOADED,
  ACCOUNT_WALLET_EXPORT,
  ACCOUNT_RESET_SYNCTIME
} from '../constants/actionTypes'
import role from '../util/role'

const generateExternalAddress = (symbol, external, type) => {
  if (symbol === 'BTC' && type === 'Coin') {
    return <span><a href={`https://blockchain.info/address/${external}`} target='_blank'>{external}</a></span>
  } else if (symbol === 'ETH' && type === 'Coin') {
    return <span><a href={`https://etherscan.io/address/${external}`} target='_blank'>{external}</a></span>
  } else {
    return (
      <span>{external}</span>
    )
  }
}
const mapStateToProps = state => ({
  ...state.account,
  currentUser: state.common.currentUser,
  csvData: state.account.csvData
});

const mapDispatchToProps = dispatch => ({
  onLoad: (payload, pageIndex) =>
    dispatch({ type: ACCOUNT_PAGE_LOADED, payload, currentPage: pageIndex }),
  onLoadNextPage: (payload, pageIndex) =>
    dispatch({ type: ACCOUNT_NEXT_PAGE_LOADED, payload, currentPage: pageIndex }),
  onUnload: () =>
    dispatch({ type: ACCOUNT_PAGE_UNLOADED }),
  onExportWallet: (payload) => {
    dispatch({ type: ACCOUNT_WALLET_EXPORT, payload })
  },
  onResetSyncTime: (payload) => {
    dispatch({ type: ACCOUNT_RESET_SYNCTIME, payload })
  }
});

class LockedAmount extends React.Component {
  render() {
    if (this.props.amount) {
      return (
        <div className="infoPair">
          <label>Locked:</label> <span>{this.props.amount}</span>
        </div>
      )
    }
    return null
  }
}

class AccountDetail extends React.Component {
  constructor() {
    super()
    this.state = {
      resetSyncTimeButtonText: 'Reset Sync Time',
    }
    this.exportWallet = (externalAddress) => ev => {
      ev.preventDefault()
      this.props.onExportWallet(agent.Accounts.exportWallet(externalAddress))
    }
    this.resetSyncTime = (key) => {
      // ev.preventDefault()
      this.props.onResetSyncTime(agent.Accounts.resetSyncTime(key))

    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.csvData) {
      var data = new Blob([nextProps.csvData], { type: 'text/csv' });
      var csvURL = window.URL.createObjectURL(data);
      var tempLink = document.createElement('a');
      tempLink.href = csvURL;
      tempLink.setAttribute('download', `${new Date()}_tasks.csv`);
      tempLink.click();
    }
  }

  componentWillMount() {
    const pageIndex = 1;
    const payload = agent.Accounts.get(this.props.match.params.key, pageIndex)
    this.props.onLoad(payload, pageIndex);
  }
  handlePageChanged(newPage) {
    //start page = 0
    const pageIndex = newPage + 1;
    const payload = agent.Accounts.get(this.props.match.params.key, pageIndex)
    this.props.onLoadNextPage(payload, pageIndex);
  }
  componentWillUnmount() {
    this.props.onUnload();
  }

  render() {
    if (!this.props.account) {
      return (
        <Loading />
      )
    }
    const account = this.props.account
    const symbol = this.props.account.symbol.toUpperCase()
    const resetSyncTimeButtonText = this.state.resetSyncTimeButtonText;
    const backLink = this.props.account.user_key === 'MASTER' ? `/masteraccounts/${this.props.account.key}` : `/users/${this.props.account.user_key}`
    return (
      <div className="pane">
        <Link className="crumb" to={backLink}>&laquo; back to user</Link>

        <h1>Account Detail</h1>
        <div className="infoGroup">
          <div className="infoPair">
            <label>Key:</label> <span>{this.props.account.key}</span>
          </div>
          <div className="infoPair">
            <label>Name:</label> <span>{this.props.account.name}</span>
          </div>
          <div className="infoPair">
            <label>Symbol:</label> <span>{this.props.account.symbol}</span>
          </div>
          <div className="infoPair">
            <label>Amount:</label> <span>{this.props.account.amount}</span>
          </div>
          <LockedAmount amount={this.props.account.amount_locked} />
          {(this.props.account.external) ? (
            <div className="infoPair">
              <label>External Address:</label> {generateExternalAddress(account.symbol, account.external, account.type)}
            </div>) : null
          }
        </div>
        <TransactionList transactions={this.props.account.transactions} loading={this.props.loading} />
        {
          this.props.account.transactions && this.props.account.transactions.length > 0 ?
            <Pager
              total={this.props.totalPage || 0}
              current={this.props.currentPage - 1}
              visiblePages={7}
              titles={{ first: '<<', last: '>>' }}
              onPageChanged={this.handlePageChanged.bind(this)}
            />
            : null
        }
        <div className="infoGroup">
          <div className="infoAction">
            {
              this.props.account.external_type === 'PRIME' ?
                <button className="buttonAction" onClick={this.exportWallet(this.props.account.external)}>Export Wallet</button>
                : null
            }

            {symbol !== 'USD' && symbol !== 'XIF' && symbol !== 'SPNC'
              && role.can(this.props.currentUser.role, ACCOUNT_RESET_SYNCTIME)
              ? <button className="buttonAction" onClick={() => {
                this.resetSyncTime(this.props.account.key);
                setTimeout(() => {
                  this.setState({ resetSyncTimeButtonText: 'Sync Time is now 0' })
                }, 2000)
              }}>
                {resetSyncTimeButtonText}
              </button>
              : null}
          </div>

        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountDetail);



// WEBPACK FOOTER //
// ./src/components/AccountDetail.js